<template>
  <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="pswp__bg"></div>
    <div class="pswp__scroll-wrap">
      <div class="pswp__container">
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>
      <div class="pswp__ui pswp__ui--hidden">
        <div class="pswp__top-bar">
          <div class="pswp__counter diy-pswp__counter"></div>
          <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
          <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
          <!-- <button class="pswp__button pswp__button--play" title="Auto play" v-if="!autoPlayFlag" @click="changeAutoPlayStatus">
          </button>
          <button class="pswp__button pswp__button--pause" title="Stop play" v-else @click="changeAutoPlayStatus">
          </button> -->
          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
          <div class="pswp__share-tooltip"></div>
        </div>
        <button type="button" class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
        </button>
        <button type="button" class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
        </button>
        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>
      </div>
    </div>
    <div class="bottom-button-area" v-show="!autoPlayFlag">
      <p type="textarea" v-if="currInfo.description" style="color:white">{{currInfo.description}}</p>
      <button class="show-info" @click="toggleShowInfos"></button>
      <button v-show="progress === 0 && !isOriginPic()" class="show-origin" @click="showOriginPic">{{$t("fullScreenPhoto.showPic")}} | {{ size }}</button>
      <button v-show="progress > 0 && progress < 100" class="show-origin" @click="showOriginPic">{{$t("fullScreenPhoto.downloading")}} | {{ progress }}%</button>
      <button class="show-download" @click="downloadPic"></button>
    </div>
    <div v-if="isShowingInfos" class="infos-area">
      <button @click="hideInfos"></button>
      <p v-if="name" :data-title="$t('fullScreenPhoto.fileName')">{{ name }}</p>
      <p v-if="width && height" :data-title="$t('fullScreenPhoto.fileSize')">{{ width }}x{{ height }}</p>
      <p v-if="exif" data-title="EXIF">{{ exif }}</p>
      <p v-if="category" :data-title="$t('fullScreenPhoto.category')">{{ category }}</p>
      <p v-if="author.name" :data-title="$t('fullScreenPhoto.authorName')" v-touch:tap="showAuthorInfos">{{ author.name }}</p>
    </div>

    <div v-show="isShowingAuthorInfos" class="author-infos" @click.self="hideAuthorInfos">
      <div>
        <h2 class="author-name">{{ author.name }}</h2>
        <p class="author-intro">{{ author.intro }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import isMobile from 'is-mobile'
import downloadjs from 'downloadjs'
// import download, { pool } from '~/assets/js/methods/download';
import Vue from 'vue'

export default {
  data: () => ({
    isListeningAfterChange: false,
    isShowingInfos: false,
    isShowingAuthorInfos: false,
    name: '',
    width: '',
    height: '',
    size: '',
    exif: '',
    category: '',
    author: {
      name: '',
      intro: ''
    },
    progress: 0,
    url: '',
    currInfo: {
      description: ''
    },
    autoPlayFlag: null
  }),
  props: {
    images: Array
  },
  methods: {
    bytesToSize (bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return '0 Byte'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    },
    changeAutoPlayStatus () {
      if (!this.autoPlayFlag) {
        if (window.gallery.ui.supportsFullscreen()) {
          window.gallery.ui.getFullscreenAPI().enter()
        }
        this.autoPlayFlag = setInterval(() => {
          window.gallery.next()
        }, 3000)
      } else {
        if (window.gallery.ui.supportsFullscreen()) {
          window.gallery.ui.getFullscreenAPI().exit()
        }
        clearInterval(this.autoPlayFlag)
        this.autoPlayFlag = null
      }
    },
    clearAutoPlayFlag () {
      if (this.autoPlayFlag) {
        //console.log(this.autoPlayFlag, 'clear')
        clearInterval(this.autoPlayFlag)
        this.autoPlayFlag = null
      }
    },
    addHeat(url) {
      let apiUrl = url.replace(/\\/g, '/') 
      apiUrl = apiUrl.replace('/photo/', '/api/addheat/')
      Vue.axios.post(apiUrl).then((res)=>{
        console.log("add heat...")
      }).catch((err)=>{
        console.log("add heat erro") +err;
      });
    },
    filterInfos () {
      const { infos, src } = window.gallery.currItem
      this.author = infos.author
      this.category = infos.category
      this.width = infos.width
      this.height = infos.height
      this.size = this.bytesToSize(infos.size)
      this.name = infos.name
      this.url = src
      //增加图片热度
      this.addHeat(src)
     
      const FNumber = infos.FNumber && ` f/${infos.FNumber}` // 光圈
      const ISO = infos.ISO && ` ISO${infos.ISO}` // ISO
      const Speed = infos.Speed && ` ${infos.Speed}` // 快门
      const Model = infos.Model && ` ${infos.Model}` // 相机型号

      if (FNumber || ISO || Speed || Model) {
        this.exif = (Model + FNumber + Speed + ISO).substr(1)
      } else {
        this.exif = ''
      }
      this.currInfo = infos
    },
    toggleShowInfos () {
      this.filterInfos()
      this.isShowingInfos = !this.isShowingInfos
    },
    hideInfos () {
      this.isShowingInfos = false
    },
    downloadPic () {
      if (isMobile()) {
        // window.location.href = window.gallery.currItem.src;
        alert(i18n.t('message.longPressSaveTips'))
      } else {
        downloadjs(window.gallery.currItem.src)
        // alert("请长按图片保存");
      }
    },
    isOriginPic () {
      return /\?size=origin/g.test(this.url)
    },
    showOriginPic () {
      const current = window.gallery.currItem.src
      const origin = `${current}?size=origin`
      // download(origin, (progress, complete) => {
      if (this.url === current) {
        // this.progress = progress;
        // if (complete) {
        window.gallery.items[window.gallery.getCurrentIndex()].src = origin
        window.gallery.invalidateCurrItems()
        window.gallery.updateSize(true)
        this.$emit('updateSrc', current, origin)
        // }
      }
      // });
    },
    showAuthorInfos () {
      this.isShowingAuthorInfos = true
    },
    hideAuthorInfos () {
      this.isShowingAuthorInfos = false
    }
  },
  mounted () {
    //console.log('addEventListener showGallery 111')
    window.addEventListener('showGallery', () => {
      if (!this.isListeningAfterChange) {
        //console.log('addEventListener showGallery 222')
        this.isListeningAfterChange = true
        window.gallery.listen('afterChange', this.filterInfos)
        window.gallery.listen('destroy', () => {
          this.isShowingInfos = false
          this.isListeningAfterChange = false
          this.clearAutoPlayFlag()
        })
      }
      this.filterInfos()
    })
  }
}
</script>
